<template>
  <div class="docs">
    <h1 class="title"></h1>
    <div class="details">
      发的发的发发发的说法打发大水发生
    </div>
  </div>
</template>

<script>

export default {
  name: 'home'
}
</script>

<style lang="scss" scoped>
.top-placeholder {
  width: 100%;
  height: 100px;
}
.banner {
  width: 100%;
  height: 500px;
  .imamge {
    width: 100%;
    height: 500px;
    background: url('../assets/03/banner.jpg') no-repeat center center / 1920px;
  }
}
.title1 {
  margin-top: 100px;
  font-size: 40px;
}
.introduce {
  margin-top: 45px;
}
.ceo {
  padding-bottom: 100px;
}
.ceo-introduce {
  width: 700px;
}
/* 团队 */
.team {
  width: 100%;
  height: 380px;
  .title3 {
    padding-top: 60px;
    font-size: 40px;
  }
  .subtitle {
    color: #eeeeee;
  }
  .team-item-box {
    margin-top: 40px;
    width: 1372px;
  }
  .item {
    height: 100px;
    margin:30px 18px 10px 18px;
    .game-imamge {
      width: 200px;
      height: 250px;
      display: block;
    }
    .desc1 {
      margin: 12px 0 0 0;
    }
    .game-desc {
      margin-left: 28px;
    }
    .normal{
      height: 100px;
    }
    .normal1{
      height: 100px;
      line-height: 100px
    }
  }
}
</style>
